(function () {
  'use strict';

  // ----------------------- Nail University slideshow -----------------------

  function initNailUni() {
    var slideshows = document.querySelectorAll('[data-neyl-slideshow]');
    for (var i = 0; i < slideshows.length; i++) {
      var box = slideshows[i];
      if (box.dataset.neylInit === 'true') continue;
      box.dataset.neylInit = 'true';

      var stepCount = parseInt(box.getAttribute('data-step-count'), 10) || 0;
      var steps = box.querySelectorAll('[data-neyl-step]');
      var dots = box.querySelectorAll('[data-neyl-dot]');
      var nextBtn = box.querySelector('[data-neyl-next]');
      var current = 0;

      function go(idx) {
        if (stepCount === 0) return;
        current = ((idx % stepCount) + stepCount) % stepCount;
        for (var j = 0; j < steps.length; j++) {
          steps[j].classList.toggle('is-active', parseInt(steps[j].getAttribute('data-neyl-step'), 10) === current);
        }
        for (var k = 0; k < dots.length; k++) {
          dots[k].classList.toggle('is-active', parseInt(dots[k].getAttribute('data-neyl-dot'), 10) === current);
        }
      }

      for (var d = 0; d < dots.length; d++) {
        (function (idx) {
          dots[idx].addEventListener('click', function () { go(idx); });
        })(d);
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () { go(current + 1); });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNailUni);
  } else {
    initNailUni();
  }
  // Re-init on shopify section reloads (theme editor)
  document.addEventListener('shopify:section:load', initNailUni);

  // ----------------------- PC hamburger → open drawer -----------------------

  function openMobileDrawer() {
    // Method 1: dispatch the standard event theme.js listens for
    try {
      document.dispatchEvent(new CustomEvent('mobile-menu:open', { bubbles: true, cancelable: true }));
      window.dispatchEvent(new CustomEvent('mobile-menu:open', { bubbles: true, cancelable: true }));
    } catch (e) {}

    // Method 2: programmatically click the existing mobile data-menu-button (if visible in DOM)
    setTimeout(function () {
      var menu = document.querySelector('.mobile-menu');
      if (menu && !menu.classList.contains('active')) {
        var existing = document.querySelector('[data-menu-button]');
        if (existing) {
          try { existing.click(); } catch (e) {}
        }
      }
    }, 30);

    // Method 3: force the active class directly
    setTimeout(function () {
      var menu = document.querySelector('.mobile-menu');
      if (menu && !menu.classList.contains('active')) {
        menu.classList.add('active');
        document.documentElement.classList.add('mobile-menu-active');
      }
    }, 120);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-neyl-drawer-open]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    openMobileDrawer();
  });

  // ----------------------- Search dropdown -----------------------

  function openSearchPanel() {
    var panel = document.querySelector('[data-neyl-search-panel]');
    if (!panel) return;
    panel.removeAttribute('hidden');

    var wrapper = panel.querySelector('[data-quick-search]');
    if (wrapper) wrapper.setAttribute('data-quick-search-active', 'true');

    // Ensure loader/results don't show until the user actually types
    var resultsWrapper = panel.querySelector('.quick-search__results-wrapper');
    if (resultsWrapper) {
      resultsWrapper.setAttribute('data-loading', 'false');
      resultsWrapper.classList.add('neyl-search-empty');
    }

    setTimeout(function () {
      var input = panel.querySelector('[data-quick-search-input]')
        || panel.querySelector('input[type="search"], input[type="text"], input[name="q"]');
      if (!input) return;
      input.focus();

      // Only show results UI when there's an actual query
      if (!input.dataset.neylListenerAttached) {
        input.dataset.neylListenerAttached = 'true';
        input.addEventListener('input', function () {
          var rw = panel.querySelector('.quick-search__results-wrapper');
          if (!rw) return;
          if (input.value.trim().length > 0) {
            rw.classList.remove('neyl-search-empty');
          } else {
            rw.classList.add('neyl-search-empty');
          }
        });
      }
    }, 20);
  }

  function closeSearchPanel() {
    var panel = document.querySelector('[data-neyl-search-panel]');
    if (panel) {
      panel.setAttribute('hidden', '');
      // Reset quick-search state so next open is clean
      var wrapper = panel.querySelector('[data-quick-search]');
      if (wrapper) wrapper.setAttribute('data-quick-search-active', 'false');
      var input = panel.querySelector('[data-quick-search-input]');
      if (input) input.value = '';
    }
  }

  document.addEventListener('click', function (e) {
    // Intercept clicks on the search trigger (only on desktop — mobile keeps default behavior)
    if (window.innerWidth >= 750) {
      var trigger = e.target.closest && e.target.closest('[data-search-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        openSearchPanel();
        return;
      }
    }

    // Close button inside the panel
    var closeBtn = e.target.closest && e.target.closest('[data-neyl-search-close]');
    if (closeBtn) {
      e.preventDefault();
      closeSearchPanel();
      return;
    }

    // Click outside the panel closes it
    var panel = document.querySelector('[data-neyl-search-panel]:not([hidden])');
    if (panel && !panel.contains(e.target) && !(e.target.closest && e.target.closest('[data-search-trigger]'))) {
      closeSearchPanel();
    }
  });

  // ESC closes search
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearchPanel();
  });

  // ----------------------- Accordion -----------------------

  function toggle(btn) {
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    var newState = !expanded;
    btn.setAttribute('aria-expanded', newState ? 'true' : 'false');
    var sublist = btn.nextElementSibling;
    if (sublist && sublist.classList.contains('neyl-drawer-sublist')) {
      if (newState) {
        sublist.removeAttribute('hidden');
      } else {
        sublist.setAttribute('hidden', '');
        // Collapse all nested expansions when parent closes
        var nestedOpen = sublist.querySelectorAll('[data-neyl-drawer-toggle][aria-expanded="true"]');
        for (var i = 0; i < nestedOpen.length; i++) {
          nestedOpen[i].setAttribute('aria-expanded', 'false');
          var s = nestedOpen[i].nextElementSibling;
          if (s && s.classList.contains('neyl-drawer-sublist')) {
            s.setAttribute('hidden', '');
          }
        }
      }
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-neyl-drawer-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  });

  // ----------------------- Hero carousel -----------------------

  function initHero(hero) {
    if (hero.dataset.neylInit === 'true') return;
    hero.dataset.neylInit = 'true';

    var track = hero.querySelector('[data-neyl-hero-track]');
    var slides = hero.querySelectorAll('[data-neyl-hero-slide]');
    var dots = hero.querySelectorAll('[data-neyl-hero-dot]');
    if (!track || slides.length === 0) return;

    var current = 0;
    var slideCount = slides.length;

    function go(idx) {
      current = (idx + slideCount) % slideCount;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === current);
        dots[i].setAttribute('aria-selected', i === current ? 'true' : 'false');
      }
    }

    for (var d = 0; d < dots.length; d++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () { go(idx); resetAutoplay(); });
      })(d);
    }

    // Touch swipe
    var startX = 0, startY = 0, dx = 0, dy = 0, dragging = false;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dx = 0; dy = 0;
      dragging = true;
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      dx = e.touches[0].clientX - startX;
      dy = e.touches[0].clientY - startY;
    }, { passive: true });
    track.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) go(current + 1); else go(current - 1);
        resetAutoplay();
      }
    });

    // Autoplay (medium speed)
    var autoplay = null;
    function startAutoplay() {
      if (slideCount <= 1) return;
      autoplay = setInterval(function () { go(current + 1); }, 5500);
    }
    function resetAutoplay() {
      if (autoplay) { clearInterval(autoplay); autoplay = null; }
      startAutoplay();
    }
    startAutoplay();

    // Pause on hover
    hero.addEventListener('mouseenter', function () {
      if (autoplay) { clearInterval(autoplay); autoplay = null; }
    });
    hero.addEventListener('mouseleave', startAutoplay);
  }

  function initAllHeroes() {
    var heroes = document.querySelectorAll('[data-neyl-hero]');
    for (var i = 0; i < heroes.length; i++) initHero(heroes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHeroes);
  } else {
    initAllHeroes();
  }

  // Re-init when drawer opens (in case it was rendered lazily via template)
  document.addEventListener('mobile-menu:open', function () {
    setTimeout(initAllHeroes, 50);
  });

  // Observe DOM changes for newly inserted drawer content
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { initAllHeroes(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  // ----------------------- Judge.me — Norwegian relative dates -----------------------
  // Judge.me's nb locale uses calendar-relative phrasing ("forrige måned", "denne uken")
  // for some ranges. We override every .jdgm-rev__timestamp with a clean
  // "X uker/måneder/år siden" format. We re-run on every DOM mutation so async-loaded
  // reviews and Judge.me re-renders are covered.

  function neylNbRelative(date) {
    var now = new Date();
    var diffMs = now.getTime() - date.getTime();
    if (diffMs < 0) diffMs = 0;
    var diffSec = Math.floor(diffMs / 1000);
    if (diffSec < 60) return 'akkurat nå';
    var diffMin = Math.floor(diffSec / 60);
    if (diffMin < 60) return diffMin + (diffMin === 1 ? ' minutt siden' : ' minutter siden');
    var diffHr = Math.floor(diffMin / 60);
    if (diffHr < 24) return diffHr + (diffHr === 1 ? ' time siden' : ' timer siden');
    var diffDay = Math.floor(diffHr / 24);
    if (diffDay < 7) return diffDay + (diffDay === 1 ? ' dag siden' : ' dager siden');
    var diffWeek = Math.floor(diffDay / 7);
    if (diffWeek < 4) return diffWeek + (diffWeek === 1 ? ' uke siden' : ' uker siden');
    var diffMonth = Math.floor(diffDay / 30);
    if (diffMonth < 12) return diffMonth + (diffMonth === 1 ? ' måned siden' : ' måneder siden');
    var diffYear = Math.floor(diffDay / 365);
    return diffYear + ' år siden';
  }

  function neylParseJdgmDate(str) {
    if (!str) return null;
    // Norwegian/EU format: DD/MM/YYYY
    var m = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (m) {
      var d = new Date(parseInt(m[3], 10), parseInt(m[2], 10) - 1, parseInt(m[1], 10));
      if (!isNaN(d.getTime())) return d;
    }
    // Fallback to native parser (handles ISO 8601 etc.)
    var d2 = new Date(str);
    if (!isNaN(d2.getTime())) return d2;
    return null;
  }

  function neylRewriteJdgmTimestamps() {
    var tss = document.querySelectorAll('.jdgm-rev__timestamp');
    for (var i = 0; i < tss.length; i++) {
      var ts = tss[i];
      var date = neylParseJdgmDate(ts.getAttribute('data-content') || ts.getAttribute('title'));
      if (!date) continue;
      var nextText = neylNbRelative(date);
      if (ts.textContent !== nextText) ts.textContent = nextText;
    }
  }

  var neylJdgmScheduled = false;
  function neylScheduleJdgmRewrite() {
    if (neylJdgmScheduled) return;
    neylJdgmScheduled = true;
    (window.requestAnimationFrame || function (cb) { setTimeout(cb, 16); })(function () {
      neylJdgmScheduled = false;
      neylRewriteJdgmTimestamps();
    });
  }

  function neylStartJdgmDates() {
    neylRewriteJdgmTimestamps();
    if (window.MutationObserver) {
      var jmMo = new MutationObserver(neylScheduleJdgmRewrite);
      jmMo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', neylStartJdgmDates);
  } else {
    neylStartJdgmDates();
  }

  // ----------------------- Hide third-party "Ingen elementer funnet" empty state -----------------------
  // A widget (Tolstoy or Judge.me) renders "Ingen elementer funnet" at the bottom of product pages
  // when it has no content to show. We can't fix it at the source (app-embed), so we walk text nodes,
  // find the phrase, climb up to the smallest container whose entire textContent is just the phrase,
  // and hide it. MutationObserver re-runs on DOM changes so async-rendered widgets are covered.

  function neylHideEmptyPhrase() {
    if (!document.body || !document.createTreeWalker) return;
    var phrase = 'ingen elementer funnet';
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var raw = node.nodeValue || '';
      if (raw.trim().toLowerCase() !== phrase) continue;
      var top = node.parentElement;
      if (!top || top.dataset.neylEmptyHidden === '1') continue;
      var climb = 4;
      while (climb-- > 0 && top.parentElement && top.parentElement !== document.body) {
        var parent = top.parentElement;
        if ((parent.textContent || '').trim().toLowerCase() === phrase) {
          top = parent;
        } else {
          break;
        }
      }
      top.dataset.neylEmptyHidden = '1';
      top.style.setProperty('display', 'none', 'important');
    }
  }

  var neylEmptyScheduled = false;
  function neylScheduleEmptyHide() {
    if (neylEmptyScheduled) return;
    neylEmptyScheduled = true;
    (window.requestAnimationFrame || function (cb) { setTimeout(cb, 16); })(function () {
      neylEmptyScheduled = false;
      neylHideEmptyPhrase();
    });
  }

  function neylStartEmptyHide() {
    neylHideEmptyPhrase();
    if (window.MutationObserver) {
      var emMo = new MutationObserver(neylScheduleEmptyHide);
      emMo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', neylStartEmptyHide);
  } else {
    neylStartEmptyHide();
  }

  // ----------------------- Kit-includes — scroll arrows -----------------------
  // The kit-includes grid overflows horizontally on narrow viewports. At sizes
  // where exactly N items fit, users can mistake those for the full set. We add
  // prev/next arrows that auto-show when there is overflow and hide at each edge.

  function neylInitKitArrows() {
    var viewports = document.querySelectorAll('[data-neyl-kit-viewport]');
    for (var i = 0; i < viewports.length; i++) {
      (function (vp) {
        if (vp.dataset.neylKitInit === '1') return;
        vp.dataset.neylKitInit = '1';
        var grid = vp.querySelector('[data-neyl-kit-grid]');
        var prev = vp.querySelector('[data-neyl-kit-arrow="prev"]');
        var next = vp.querySelector('[data-neyl-kit-arrow="next"]');
        if (!grid) return;

        function updateArrows() {
          if (!grid.clientWidth) return; // collapsed accordion or hidden
          var hasOverflow = grid.scrollWidth > grid.clientWidth + 1;
          var atStart = grid.scrollLeft <= 1;
          var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 1;
          if (prev) prev.hidden = !hasOverflow || atStart;
          if (next) next.hidden = !hasOverflow || atEnd;
        }
        function scrollByAmount(direction) {
          var amount = Math.max(grid.clientWidth * 0.8, 200);
          if (typeof grid.scrollBy === 'function') {
            grid.scrollBy({ left: direction * amount, behavior: 'smooth' });
          } else {
            grid.scrollLeft += direction * amount;
          }
        }
        if (prev) prev.addEventListener('click', function () { scrollByAmount(-1); });
        if (next) next.addEventListener('click', function () { scrollByAmount(1); });
        grid.addEventListener('scroll', updateArrows);
        window.addEventListener('resize', updateArrows);
        if (window.ResizeObserver) {
          var ro = new ResizeObserver(updateArrows);
          ro.observe(grid);
        }
        // Re-check once images finish loading (they affect scrollWidth)
        var imgs = grid.querySelectorAll('img');
        for (var k = 0; k < imgs.length; k++) {
          if (!imgs[k].complete) imgs[k].addEventListener('load', updateArrows);
        }
        updateArrows();
      })(viewports[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', neylInitKitArrows);
  } else {
    neylInitKitArrows();
  }
  document.addEventListener('shopify:section:load', neylInitKitArrows);

  // ----------------------- Trust carousel — mobile dots + autoplay -----------------------
  function neylInitTrust() {
    var sections = document.querySelectorAll('[data-neyl-trust]');
    for (var i = 0; i < sections.length; i++) {
      (function (sec) {
        if (sec.dataset.neylTrustInit === '1') return;
        sec.dataset.neylTrustInit = '1';
        var track = sec.querySelector('[data-neyl-trust-track]');
        var slides = sec.querySelectorAll('[data-neyl-trust-slide]');
        var dots = sec.querySelectorAll('[data-neyl-trust-dot]');
        if (!track || slides.length === 0) return;

        function activeIdx() {
          if (!track.clientWidth) return 0;
          return Math.round(track.scrollLeft / track.clientWidth);
        }
        function goTo(idx) {
          if (idx < 0) idx = 0;
          if (idx >= slides.length) idx = slides.length - 1;
          var left = idx * track.clientWidth;
          if (typeof track.scrollTo === 'function') {
            track.scrollTo({ left: left, behavior: 'smooth' });
          } else {
            track.scrollLeft = left;
          }
        }
        function updateUI() {
          var idx = activeIdx();
          for (var k = 0; k < dots.length; k++) {
            dots[k].classList.toggle('is-active', k === idx);
          }
        }

        for (var d = 0; d < dots.length; d++) {
          (function (idx) {
            dots[idx].addEventListener('click', function () {
              goTo(idx);
              stopAutoplay();
            });
          })(d);
        }

        var debounce = null;
        track.addEventListener('scroll', function () {
          if (debounce) clearTimeout(debounce);
          debounce = setTimeout(updateUI, 80);
        });
        window.addEventListener('resize', updateUI);
        if (window.ResizeObserver) {
          var ro = new ResizeObserver(updateUI);
          ro.observe(track);
        }

        var autoplayEnabled = sec.dataset.autoplay === '1';
        var autoplayMs = (parseInt(sec.dataset.autoplayInterval || '5', 10) || 5) * 1000;
        var timer = null;
        function startAutoplay() {
          if (!autoplayEnabled || slides.length <= 1 || timer) return;
          timer = setInterval(function () {
            var idx = activeIdx();
            goTo(idx >= slides.length - 1 ? 0 : idx + 1);
          }, autoplayMs);
        }
        function stopAutoplay() {
          if (timer) { clearInterval(timer); timer = null; }
        }
        if (autoplayEnabled) {
          sec.addEventListener('mouseenter', stopAutoplay);
          sec.addEventListener('mouseleave', startAutoplay);
          sec.addEventListener('touchstart', stopAutoplay, { passive: true });
          startAutoplay();
        }

        updateUI();
      })(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', neylInitTrust);
  } else {
    neylInitTrust();
  }
  document.addEventListener('shopify:section:load', neylInitTrust);
})();

// ----------------------- Judge.me badge — 1-decimal rounding -----------------------
// Inline product-item.liquid <script> tags don't execute when Shopify's Section
// Rendering API replaces a section via innerHTML (browser security). On product
// pages where no other product cards render server-side, recommendations load
// async and the inline rounding logic never runs. This globally-loaded copy
// fires once on page load and observes the DOM for any badge added later.
(function () {
  if (window.__neylGlobalBadgeRound) return;
  window.__neylGlobalBadgeRound = true;
  function run() {
    document.querySelectorAll('.neyl-jm-card-badge--jm .jdgm-prev-badge[data-average-rating]').forEach(function (el) {
      var v = parseFloat(el.getAttribute('data-average-rating'));
      if (isNaN(v)) return;
      var rounded = (Math.floor(v * 10) / 10).toFixed(1);
      if (el.getAttribute('data-average-rating') !== rounded) {
        el.setAttribute('data-average-rating', rounded);
      }
    });
  }
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || function (cb) { setTimeout(cb, 16); })(function () {
      scheduled = false;
      run();
    });
  }
  function start() {
    run();
    if (window.MutationObserver) {
      var mo = new MutationObserver(schedule);
      mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-average-rating'] });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
